/** 静态登录页地址（public/login.html） */
export const LOGIN_PATH = '/login.html';

/** 跳转到静态登录页；可选带回跳地址 */
export function redirectToLogin(redirect?: string) {
  const target = redirect
    ? `${LOGIN_PATH}?redirect=${encodeURIComponent(redirect)}`
    : LOGIN_PATH;
  window.location.replace(target);
}
